import dayjs from 'dayjs';
import { VisitDetail } from '../../../../entity';
import { normalizeDate } from '../../../../schedule/store';

export const useHasAnyManualVisit = (visits: VisitDetail[] | undefined) => {
  const hasAnyManualVisit = (date?: string): boolean => {
    if (!visits?.length) {
      return false;
    }

    const filteredVisits = date
      ? visits.filter(({ visit }) => normalizeDate(visit.dateFrom) === date)
      : visits;

    return filteredVisits.some(({ visit, services }) => {
      const serviceBlocks = services.flatMap(service => service.blocks);

      if (!serviceBlocks.length) {
        return false;
      }

      const totalDuration = serviceBlocks.reduce((sum, block) => sum + block.duration, 0);
      const actualDuration = dayjs(visit.dateTo).diff(dayjs(visit.dateFrom), 'minute');

      return totalDuration !== actualDuration;
    });
  };

  return hasAnyManualVisit;
};
